import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WordStatus } from '@shared/types';

/**
 * The key to the word colours, shown under the text.
 *
 * Each label is itself a `.word-element.<status> .word`, so it takes its
 * colour (and the coarticulated dotted line) from the same stylesheet as
 * the reading and cannot drift from it. No sample word: the label is the
 * sample. The order is the order a reader meets them: read, nearly read,
 * swallowed into the next word, wrong, never heard. "Not read yet" comes
 * first: it is the ink the text starts in, and a colour-blind reader tells
 * read from not-yet by where the cursor is, not by the green.
 */
const KEY: { status: WordStatus; label: string }[] = [
  { status: WordStatus.Pending, label: 'wordKeyPending' },
  { status: WordStatus.Correct, label: 'wordKeyCorrect' },
  { status: WordStatus.Near, label: 'wordKeyNear' },
  { status: WordStatus.Coarticulated, label: 'wordKeyCoarticulated' },
  { status: WordStatus.Mistake, label: 'wordKeyWrong' },
  { status: WordStatus.Missing, label: 'wordKeySkipped' },
];

const Legend = () => {
  const { t } = useTranslation();

  return (
    <Box
      data-tour="word-key"
      role="list"
      aria-label={t('wordKeyTitle')}
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        columnGap: 2.5,
        rowGap: 0.5,
        px: 1,
      }}
    >
      {KEY.map(({ status, label }) => (
        <Typography
          key={status}
          role="listitem"
          variant="body2"
          component="span"
          className={`word-element ${status}`}
          sx={{ fontWeight: 600 }}
        >
          <span className="word">{t(label)}</span>
        </Typography>
      ))}
    </Box>
  );
};

export default Legend;
